import GLightbox from 'glightbox'

const initCarListingGlightBox = () => {
  GLightbox({
    selector: '.car-listing-glightbox'
  });
}

export default initCarListingGlightBox;
